import React, { useContext } from "react";
import { GlobalContext } from '../../contexts/GlobalContext';
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import PageTitle from "../../components/PageTitle/PageTitle";
import ResponsiveImage from "../../components/ResponsiveImage/ResponsiveImage";



const Cubage = () => {
    const { state } = useContext(GlobalContext);
    const language = state.language || 'pt-br';
    const {
        breadcrumb,
        selectedPage,
        breadCrumbImage,
        pageTitle,
        pageSubtitle,
        cubageInfo,
        cubageDifferenceTitle,
        cubageDifference1,
        cubageDifference2,
        cubageDifference3
    } = require(`../../assets/languages/${language}/cubage.json`);
    return (
        <>
            <Breadcrumb
                beforeRoutes={breadcrumb}
                classColor='white100'
                selectedPage={selectedPage}
                image={breadCrumbImage}
            />
            <div className='main-container mg-bot-100'>
                <section className="section-container">
                    <PageTitle title={pageTitle} subtitle={pageSubtitle} />
                    <span className="mg-bot-70">{cubageInfo}</span>
                    <ResponsiveImage image={'cubage-air-plane.png'} height='350px'/>
                    <span className="text-title-secondary mg-top-20">{cubageDifferenceTitle}</span>
                    <span className="mg-top-20">{cubageDifference1}</span>
                    <span className="mg-top-20">{cubageDifference2}</span>
                    <span className="mg-top-20 gray300">{cubageDifference3}</span>
                </section>
            </div>
        </>
    )

}

export default Cubage